import React from 'react';
import { Input, Label } from 'reactstrap';
import {Form, Button, Checkbox, Table, Popup, Icon, Loader, Grid} from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import axios from "axios";
import {
    fetchStudyCycle,
} from "../../Lookups/util";
import ReactExport from "react-data-export";

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class LockedGraduatedStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            endDateErr: false,
            startDateErr: false,

            startDate: null,
            endDate: new Date(),

            organizationalUnitId: null,

            student: null,
            studyCycles:[],
            studyCycle: null,

            studyProgramBasicId: null,
            studyProgramBasics: [],
            studyProgramBasicsAll: [],

            loaded: null,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            unsa: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),

            results: [],
            students:[],
            excelData:[],


        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkDate = this.checkDate.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.filter = this.filter.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post(this.state.unsa ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.all([ fetchStudyCycle()])
            .then(axios.spread(( studyCycleRes) => {
                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                this.setState({
                    studyCycles
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch studyCycles.');
            });
    }

        getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData: this.state.unsa ?  this.state.students.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : this.state.students.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.department},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.title},
                    ]))});
        }
       else{
            this.setState({ results,
                excelData: this.state.unsa ?  results.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : results.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.department},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.title},
                    ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    checkDate() {
        if (this.state.startDate && !this.state.endDate) {
            toast('Morate unijeti i datum kraja!');
            this.setState({ endDateErr: true });
        } else if (!this.state.startDate && this.state.endDate) {
            toast('Morate unijeti i datum početka!');
            this.setState({ startDateErr: true });
        } else {
            this.setState({ startDateErr: false, endDateErr: false });
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }

        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        if (name === 'endDate') {
            if (this.state.startDate && date < this.state.startDate) {
                toast('Datum kraja mora biti poslije datuma početka!');
            } else  this.setState({
                [name]: date
            });
        }

        if (name === 'startDate') {
            if (this.state.endDate && date > this.state.endDate) {
                toast('Datum početka mora biti prije datuma kraja!');
            } else
                this.setState({
                [name]: date
            });
        }
    }

    filter(){
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
          studyCycle: this.state.studyCycle,
        };
        if (this.state.locked) obj = { ...obj, locked: this.state.locked };
        if (this.state.graduated) obj = { ...obj, graduated: this.state.graduated };
        if (this.state.startDate) obj = { ...obj, startDate: this.state.startDate };
        if (this.state.endDate) obj = { ...obj, endDate: this.state.endDate };
        if (this.state.studyProgramBasicId) obj = { ...obj, studyProgramBasicId: this.state.studyProgramBasicId };

        if(this.state.unsa){
            axios.post('reports/graduated-students-count/', { ...obj })
                .then(res => {

                    this.setState({   students: res.data, loaded: true,
                        excelData: res.data.map(el => ([
                            { value: el.organizationalUnitName },
                            { value: el.numberOfStudents},
                        ]))
                    })})
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
        else{
        axios.post('/graduation-documents/', { ...obj })
            .then(res => {
                this.setState({
                    students: res.data.map(el => ({
                        ...el,
                        date: moment(el.dateOfGraduation).format('D. M. YYYY.'),
                        department:el.departmentsSPOU[0].organizationalUnitName
                    })), loaded: true,
                    excelData: res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.departmentsSPOU[0].organizationalUnitName},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.title},
                    ]))});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch graduation documents');
            });}
    }
    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Broj diplome', width: { wpx: 150 } },
                    { title: 'Datum diplimiranja', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 300 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'NPP', width: { wpx: 150 } },
                    { title: 'Zvanje', width: { wpx: 400 } }
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 150 } },
                    { title: 'Broj studenata', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required >
                            <Form.Dropdown
                                label="Ciklus studija"
                                placeholder="Odaberite ciklus studija"
                                value={this.state.studyCycle}
                                onChange={this.handleInputChange}
                                name="studyCycle"
                                options={this.state.studyCycles}
                                search
                                fluid
                                required
                                selection

                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field />

                    </Form.Group>


                    <Form.Group widths="equal">
                        <Form.Field error={this.state.startDateErr}>
                            <label >Datum početka</label>
                            <DateTimePicker
                                format="D .M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                value={this.state.startDate}
                            />
                        </Form.Field>
                        <Form.Field error={this.state.endDateErr}>
                            <label>Datum kraja</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                value={this.state.endDate}
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Field >
                    <Checkbox
                        type="checkbox"
                        name="graduated"
                        id="graduated"
                        onChange={(e) => this.setState({ graduated: !this.state.graduated})}
                        checked={this.state.graduated}
                        label="Diplomirani studenti"
                    />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group>
                        <Form.Field >

                    <Checkbox
                        type="checkbox"
                        name="locked"
                        id="locked"
                        onChange={(e) => this.setState({ locked: !this.state.locked})}
                        checked={this.state.locked}
                        label="Zaključani studenti"
                    />
                        </Form.Field>
                    </Form.Group>

                    <br /><br />

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right"  disabled={!this.state.studyCycle} onClick={this.filter}>Filtriraj
                    </Button>

                </Form>

                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.students.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={this.state.unsa ? 2 : 16} >
                                <Grid column={2} stackable>
                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['lastName', 'firstName', 'fatherName', 'indexNumber', 'documentNumber', 'dateOfGraduation', 'department', 'studyProgramBasicName', 'studyProgramName', 'title' ]} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign="center">
                                        <ExcelFile filename="Diplomirani studenti" element={<Popup
                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                        </ExcelFile>

                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                    {this.state.unsa ? <Table.Row>
                            <Table.HeaderCell >Organizaciona jedinica</Table.HeaderCell>
                            <Table.HeaderCell >Broj studenata</Table.HeaderCell>
                        </Table.Row>
                        : <Table.Row>
                            <Table.HeaderCell width={1}>
                                R. br.
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Prezime (ime oca) i ime</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Studijski program</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Broj diplome</Table.HeaderCell>
                            <Table.HeaderCell width={4}>Index</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Datum diplomiranja</Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Zvanje</Table.HeaderCell>
                        </Table.Row>}
                    </Table.Header>
                            {this.state.unsa ?
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.organizationalUnitName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudents}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                                : <Table.Body collapsing> {currentPosts.map((row, index) => (
                                     <Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle" collapsing>
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                        </Table.Cell>
                                        <Table.Cell colSpan={3}>{row.locked ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null} {row.lastName} ({row.fatherName}) {row.firstName} </Table.Cell>
                                        <Table.Cell colSpan={2}>{row.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}</Table.Cell>
                                        <Table.Cell colSpan={2} ><strong>{row.studyProgramBasicName}</strong> | {row.studyProgramName}</Table.Cell>
                                        <Table.Cell colSpan={2}>{row.documentNumber}</Table.Cell>
                                        <Table.Cell width={4}>{row.indexNumber}</Table.Cell>
                                        <Table.Cell colSpan={2}>{row.dateOfGraduation === null ? null : moment(row.dateOfGraduation).format('D. M. YYYY.')}</Table.Cell>
                                        <Table.Cell colSpan={3}>{row.title}</Table.Cell>
                                    </Table.Row>
                                  ))}
                                </Table.Body>}
                </Table> : 'Nema podataka.'}

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
             </div>}
                <ToastContainer hideProgressBar />
                    </div>
                    );
                }
                }



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/LockedGraduatedStudents.js